import { closeToast, setToastDefaultOptions, showConfirmDialog, showDialog, showLoadingToast, showToast } from 'vant'

export function configureFeedback() {
  setToastDefaultOptions({ duration: 1800, forbidClick: false })
}

export interface ConfirmOptions {
  title?: string
  message: string
  confirmButtonText?: string
  cancelButtonText?: string
}

export function toast(message: string, type: 'success' | 'fail' | 'loading' | 'text' = 'text') {
  showToast({ message, type: type === 'text' ? 'text' : type })
}

export function loading(message = '加载中...') {
  return showLoadingToast({ message, forbidClick: true, duration: 0 })
}

export function hideLoading() {
  closeToast()
}

export async function confirm(options: ConfirmOptions) {
  try {
    await showConfirmDialog({
      title: options.title || '提示',
      message: options.message,
      confirmButtonText: options.confirmButtonText || '确定',
      cancelButtonText: options.cancelButtonText || '取消',
    })
    return true
  }
  catch {
    return false
  }
}

export async function alert(message: string, title = '提示') {
  await showDialog({ title, message })
}
